import React, { useEffect, useRef, useState,forwardRef,useImperativeHandle } from 'react';
import DigitImage from './DigitImage';
import { parseClasses } from '../../lib/ep';

const splitTime = (miliseconds) => {
	let remaining = miliseconds;

	let minutes = Math.floor(remaining / 60000);
	if(minutes > 0) {
		remaining -= Math.floor(minutes)*60000;
		if(minutes < 10) minutes = `0${minutes}`;
	}

	let seconds = Math.floor(remaining / 1000);
	remaining -= seconds * 1000;
	if(seconds < 10) seconds = `0${seconds}`;

	let milis = Math.floor(remaining / 100);

	return [ minutes, seconds, milis];
};

const formatCounterItems = (format_str, full_labels) => {
	const format_arr_temp = format_str.split("");

	const format_arr = [];
	for(var i = 0; i < format_arr_temp.length; i++) {
		switch(format_arr_temp[i]) {
			case 'D':
				format_arr.push({
					label:(full_labels) ? "day" : "d",
					type:'days',
					value:'d',
				});
				break;
			case 'h':
				format_arr.push({
					label:(full_labels) ? "hou" : "h",
					type:'hours',
					value:'h',
				});
				break;
			case 'm':
				format_arr.push({
					label:(full_labels) ? "min" : "m",
					type:'minutes',
					value:'m',
				});
				break;
			case 's':
				format_arr.push({
					label:(full_labels) ? "sec" : "s",
					type:'seconds',
					value:'s',
				});
				break;
			case 'd':
				//display_decimal_seconds = true;
				break;
			case ':':
				format_arr.push({
					label:false,
					type:'colon',
					value:false,
				});
				break;
			case '.':
				format_arr.push({
					label:false,
					type:'dot',
					value:false,
				});
				break;
			case ' ':
			default:
				break;
		}
	}

	return format_arr;
};

const TimeCounterPerform = forwardRef(({seconds,...props},ref) => {
	const miliseconds = seconds * 1000;

	const simplified_decimals = true; // Do not show decimals over 60 secs
	const display_if_zero = false // Do not show digits if they are 0
	const only_digit = true;
	const format = formatCounterItems((props?.format ?? 'D h:m:s'), props?.full_labels ?? true);
	const start_time = useRef(false);
	const elapsed_time = useRef(false);
	const remaining_time = useRef(miliseconds);
	const timer = useRef(null);

	const [ splitted, setSplitted ] = useState(splitTime(miliseconds));

	const startCounter = () => {
		start_time.current = Date.now()
		timer.current = setInterval(setElapsed, 100);
	};

	useEffect(() => {
		if(props?.stopped == true) return;
		startCounter();

		return () => {
			clearInterval(timer.current);
		}
	}, [ props?.stopped ]);

	useEffect(() => {
		setSplitted(splitTime(miliseconds));
	}, [ seconds ]);

	useImperativeHandle(ref, () => ({
		getElapsedAndStop() {
			if(timer.current) {
				elapsed_time.current = Date.now() - start_time.current;
				remaining_time.current = Math.max(0, miliseconds - elapsed_time.current);
				clearInterval(timer.current);
			}
			return elapsed_time;
		},
		getElapsedInSeconds() {
			return elapsed_time.current / 1000;
		},
		getRemainingInSeconds() {
			return remaining_time.current / 1000;
		},
		resetTimer(autostart = false) {
			elapsed_time.current = false;
			remaining_time.current = miliseconds;
			setSplitted(splitTime(miliseconds));
			if(autostart) startCounter();
		},
		startTimer() {
			startCounter();
		},
	}), []);

	const setElapsed = () => {
		elapsed_time.current = Date.now() - start_time.current;
		remaining_time.current = Math.max(0, miliseconds - elapsed_time.current);
		if(remaining_time.current <= 0) {
			clearInterval(timer.current);
			if(props.onEnd != undefined) props.onEnd();
		}
		setSplitted(splitTime(remaining_time.current));
	};

	const hurry_mode = (splitted[0] == 0 && splitted[1] < 10) ? true : false;

	const classes = props?.classes ?? 'hasCountdown';

	const type = props?.type ?? 'normal';
	const in_text = props?.in_text ?? true;

	if(type == 'clock') {
		let bigger_item = 0;

		const time = {
			m:splitted[0],
			s:splitted[1],
			d:splitted[2],
		};

		const label_color = props?.label_color ?? false;
		const hide_labels = props?.hide_labels ?? false;
		const only_digit = props?.only_digit ?? true;

		let classname = props?.classname ?? 'gui_time_countdown';
		classname = parseClasses(classname, props._class, 'timecounter');
		if(hurry_mode && !props.count_up) classname += ' hurry_up';
		if(props?._hidden ?? false) classname += 'hidden';

		return (
			<div class={classname}>
				{(props.children) && (
					<FieldLabel
						{...props.label_props}
						name={props.name}
						autotranslate={props.autotranslate}
					>{props.children}</FieldLabel>
				)}

				<div class={classes}>
					<div class="time countdown_row countdown_amount">
						{format.map((item, i) => {
							if(simplified_decimals && seconds > 60 && item.type == "decimal_seconds") {
								return null;
							}

							if(bigger_item == i && !display_if_zero && item.value && parseInt(time[item.value]) === 0) {
								bigger_item++;
								return null;
							}

							return (
								<span key={i} class={(!item.value) ? 'is_separator' : null}>
									{(in_text) ? (
										<strong>{(item.value) ? time[item.value] : item.type}</strong>
									) : (
										<DigitImage
											only_digit={only_digit}
											value={(item.value) ? time[item.value] : item.type}
										/>
									)}

									{(item.label && !hide_labels) && (
										<em style={(label_color) ? { color:label_color } : null}>{item.label}</em>
									)}
								</span>
							)
						})}
					</div>
				</div>
			</div>
		)
	}

	return (
		<div class={(hurry_mode) ? 'hurry_up' : null}>
			<div class={classes}>
				<div class="time countdown_row countdown_amount">
					{(splitted[0] != 0) && (
						<>
							<span>
								{(in_text) ? (
									<strong>{splitted[0]}</strong>
								) : (
									<DigitImage
										only_digit={only_digit}
										value={splitted[0]}
									/>
								)}
							</span>

							<span class="is_separator">
								{(in_text) ? (
									<strong>:</strong>
								) : (
									<DigitImage
										only_digit={only_digit}
										value=":"
									/>
								)}
							</span>
						</>
					)}

					<span>
						{(in_text) ? (
							<strong>{splitted[1]}</strong>
						) : (
							<DigitImage
								only_digit={only_digit}
								value={splitted[1]}
							/>
						)}
					</span>

					{(splitted[0] == 0) && (
						<>
							<span class="is_separator">
								{(in_text) ? (
									<strong>.</strong>
								) : (
									<DigitImage
										only_digit={only_digit}
										value="."
									/>
								)}
							</span>

							<span>
								{(in_text) ? (
									<strong>{splitted[2]}</strong>
								) : (
									<DigitImage
										only_digit={only_digit}
										value={splitted[2]}
									/>
								)}
							</span>
						</>
					)}
				</div>
			</div>
		</div>
	)
});

export default TimeCounterPerform;